import { render, staticRenderFns } from "./CampaignMessageEditor.html?vue&type=template&id=b9fcb230&scoped=true&external"
import script from "./CampaignMessageEditor.js?vue&type=script&lang=js&external"
export * from "./CampaignMessageEditor.js?vue&type=script&lang=js&external"
import style0 from "./CampaignMessageEditor.scss?vue&type=style&index=0&id=b9fcb230&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fcb230",
  null
  
)

export default component.exports